import axios from "axios";

import { authHeader, checkToken } from "../util/authUtil.ts";
import { toastFunc } from "../util/toast.ts";

const API: string = import.meta.env.VITE_API_BASE_URL;
//const API = "http://10.9.8.101:8080";
//const API = "https://demo.api.client.eapp.ito.dev";
//const API = "https://termini-b.mvp.gov.ba";
//const API = "https://localhost:44367";
//const API = "https://api.client.eappointment.ito.dev";
//const API_TEST = "http://82d9-185-98-0-24.ngrok-free.app";
//const API = "http://10.9.8.101:8082";
//const API = "http://10.1.2.5:84"; //MVP

export const getFunc = async (url: string) => {
  return axios
    .get(`${API}/${url}`, {
      headers: {
        ...authHeader(),
      },
    })
    .then((response) => {
      checkToken();
      return response;
    })
    .catch((error) => {
      checkToken();
      return toastFunc(error.message, "error");
    });
};
export const getFuncTest = async (url: string) => {
  return axios
    .get(`${API}/${url}`, {
      headers: {
        ...authHeader(),
      },
    })
    .then((response) => {
      checkToken();
      return response;
    })
    .catch((error) => {
      checkToken();
      return toastFunc(error.message, "error");
    });
};
export const postFunc = async (url: string, body: string | object) => {
  return axios
    .post(`${API}/${url}`, body, {
      headers: {
        ...authHeader(),
      },
    })
    .then((response) => {
      checkToken();
      return response;
    })
    .catch((error) => {
      checkToken();
      return error.response;
    });
};

export const putFunc = async (url: string, body: string | object) => {
  return axios
    .put(`${API}/${url}`, body, {
      headers: {
        ...authHeader(),
      },
    })
    .then((response) => {
      checkToken();
      return response;
    })
    .catch((error) => {
      checkToken();
      return error.response;
    });
};
export const delFunc = async (url: string) => {
  return axios
    .delete(`${API}/${url}`, {
      headers: {
        ...authHeader(),
      },
    })
    .then((response) => {
      checkToken();
      return response;
    })
    .catch((error) => {
      checkToken();
      return toastFunc(error.message, "error");
    });
};
